var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    Dated this "),_c('span',{staticClass:"underline"},[_vm._v(_vm._s(_vm.date))]),_vm._v(" day of\n    "),_c('span',{staticClass:"underline"},[_vm._v(_vm._s(_vm.month))]),_vm._v(" "+_vm._s(_vm.year)+".\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }